import { render, staticRenderFns } from "./PscGeneral.vue?vue&type=template&id=542e043f&scoped=true&"
import script from "./PscGeneral.vue?vue&type=script&lang=js&"
export * from "./PscGeneral.vue?vue&type=script&lang=js&"
import style0 from "./PscGeneral.vue?vue&type=style&index=0&id=542e043f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542e043f",
  null
  
)

export default component.exports